import React, { useEffect, useState } from "react";
import { FormControl } from "react-bootstrap";
import { SearchIcon } from "../Global/Icons";

type Props = {
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
  debounceMs?: number;
  label?: string;
};

export default function UsersSearch({
  value,
  onChange,
  placeholder = "Search by name, email, role, project...",
  debounceMs = 200,
  label = "Search users",
}: Props) {
  const [local, setLocal] = useState(value);

  useEffect(() => setLocal(value), [value]);

  useEffect(() => {
    const t = setTimeout(() => {
      if (local !== value) onChange(local);
    }, debounceMs);
    return () => clearTimeout(t);
  }, [local, value, onChange, debounceMs]);

  return (
    <div className="d-flex align-items-center w-100 text-muted">
      <SearchIcon width={20} className="me-1" />

      <FormControl
        type="search"
        className="border-0 shadow-none flex-grow-1"
        value={local}
        aria-label={label}
        placeholder={placeholder}
        onChange={(e) => setLocal(e.target.value)}
      />
    </div>
  );
}
